import type { BaseMessage } from '@sendbird/chat/message';
import {
  formatSendbirdSenderNameRole,
  getSendbirdMessageSender,
  type SendbirdDisplayOptions,
} from '../../helpers/sendbirdDisplay';

type SendbirdIncomingMessageHeaderProps = {
  message: BaseMessage;
  currentUserId: string;
  sendbirdDisplayOptions?: SendbirdDisplayOptions;
};

/** NAZ-604 P2: `{Name} - {Role}:` above incoming message bubbles. */
export const SendbirdIncomingMessageHeader = ({
  message,
  currentUserId,
  sendbirdDisplayOptions,
}: SendbirdIncomingMessageHeaderProps) => {
  const sender = getSendbirdMessageSender(message);
  if (!sender?.userId || sender.userId === currentUserId) {
    return null;
  }

  const label = formatSendbirdSenderNameRole(sender, sendbirdDisplayOptions);
  if (!label) return null;

  return <div className="sendbird-message-content__middle__sender-name">{label}:</div>;
};

export default SendbirdIncomingMessageHeader;
